<template>
    <div class="relative bg-black overflow-hidden" style="height: 0; padding-bottom: 70%">
        <div ref="wrap" class="absolute inset-0" style="top: -51px !important">
            <iframe class="w-full" :style="{ height: `${height}px` }"
                :src="sourceUrl"
                kwframeid="1"
                scrolling="no"
            />
        </div>
    </div>
</template>

<script>
    import IframePlayer from './IframePlayer'

    export default {
        components: {
            IframePlayer,
        },

        data() {
            return {
                height: 0,
                resizeHandler: null,
            }
        },

        props: {
            video: { type: Object, required: true },
            autoplay: { type: Boolean, default: false },
        },

        computed: {
            videoId() {
                return this.video.video_host_id
            },

            sourceUrl() {
                return `https://app.krossover.com/${this.videoId}`
            },
        },
        
        methods: {
            checkHeight() {
                this.height = this.$refs.wrap.offsetHeight
            },
        },

        mounted() {
            this.checkHeight()
            window.addEventListener('resize', this.resizeHandler = () => this.checkHeight())
        },

        beforeDestroy() {
            if (this.resizeHandler) {
                window.removeEventListener('resize', this.resizeHandler)
            }
        }
    }
</script>
